/**
 * Ops Playbook Builder Lesson
 * Skill Area: Operations
 * Turn expertise into reusable AI tools
 */

import type { LessonDefinition } from '../types';
import { OPS_PLAYBOOK_AI_PROMPT, OPS_PLAYBOOK_CONTEXT_SCENARIOS } from '../prompts/ops-playbook-builder.prompt';

export const opsPlaybookBuilder: LessonDefinition = {
  id: 'ops-playbook-builder',
  title: 'Playbook Builder',
  displayTitle: 'Learn to Build with AI',
  subTitle: 'Turn your expertise into a reusable AI tool.',
  tagline: "Turn your expertise into a reusable AI tool.",
  persona: 'Lyra',
  skillArea: 'Operations',
  format: 'tool_lab',
  difficulty: 'Intermediate',
  estimatedMinutes: 7,
  tags: ['ops', 'documentation', 'playbook'],
  dailyEligible: true,
  releasedAt: '2025-02-18T00:00:00.000Z',
  route: '/micro/ops-playbook-builder',
  storyBeat: 'Lyra helps you document the process so anyone can run it tomorrow.',
  learningMode: 'puzzle',
  contextTitle: "Playbook starter",
  contextSummary: "Grab the process that keeps living in someone's head and let Lyra capture it with roles, timing, and guardrails.",
  contextScenarios: OPS_PLAYBOOK_CONTEXT_SCENARIOS,
  introPrompt: "Right now, that critical process you run? It lives in your head. You've become the bottleneck without meaning to. Let's fix that.",
  steps: [
    "Identify a process people always ask you about",
    "Answer 4 questions to extract complete process knowledge",
    "Get your reusable Playbook Builder prompt",
    "Practice on a second process to prove mastery"
  ],
  promptGuidance: 'Choose a process below or type your own.',
  aiPrompt: OPS_PLAYBOOK_AI_PROMPT,
  inputPlaceholder: "Type 'Event Setup' or your own process...",
  quickPrompts: [
    'Event Setup Checklist',
    'Grant Reporting Workflow',
    'New Volunteer Onboarding'
  ]
};
